import { useCallback, useEffect, useRef, useState } from "react";
import { get } from "utils/DeApi";

const useFetchActionItemById = ({ actionItemId }) => {
  const subscribedPromises = useRef([]);

  const [error, setError] = useState("");
  const [actionItem, setActionItem] = useState({});
  const [isLoading, setIsLoading] = useState("");

  const fetchActionItemById = useCallback(() => {
    if (!actionItemId) return;
    setIsLoading(true);
    setError(null);
    const actionItemPromise = get(`action-items/${actionItemId}`);
    actionItemPromise.promise
      .then(({ data }) => {
        setActionItem(data ?? []);
        return data;
      })
      .catch((error) => !error.isCanceled && setError(error))
      .finally(() => setIsLoading(false));
    subscribedPromises.current.push(actionItemPromise);

    return actionItemPromise.promise;
  }, [actionItemId]);

  useEffect(() => {
    const promises = subscribedPromises.current;
    return () => {
      promises.forEach((promise) => {
        promise.cancel();
      });
    };
  }, [fetchActionItemById]);

  return {
    actionItem,
    isLoading,
    error,
    fetchActionItemById,
  };
};

export default useFetchActionItemById;
